import { isRejectedWithValue } from "@reduxjs/toolkit";
import { clearSentryUser } from "utils/sentry";

export const authMiddleware = () => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        if (action.payload?.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            clearSentryUser();

            // Avoid infinite redirect loop if already on login page
            if (window.location.pathname !== "/login") {
                window.location.href = "/login";
            }
        }
    }

    return next(action);
};
